import React from 'react'
import styled from 'styled-components'
import Colors from '../Colors'
import RoundButton from './RoundButton'
import ModalResponsive from './ModalResponsive'

/**
 * @param {string} buttonColorStyle - cor do botão de confirmação (background e border) e cancelamento (color e borderColor)
 * @param {string} confirmButtonText - texto que será exibido no botão de confirmação
 * @param {string} footerAlignment - alinhamento do footer (pode ser 'center' ou 'right')
 * @param {boolean} isCloseIconVisible - se o botão de fechar ficará visível ou não
 * @param {boolean} isLoading - se está tendo algum carregamento
 * @param {boolean} isCancelButtonVisible - se o botão de cancelamento ficará visível ou não
 * @param {boolean} isVisible - se o componente está visível ou não
 * @param {React.FunctionComponent} renderMessage - componente a ser renderizado como mensagem de confirmação
 * @param {string} title - título do componente
 * @param {function} onClose - ação a ser feita ao fechar o componente
 * @param {function} onConfirm - ação a ser feita ao confirmar a ação
 */

const ConfirmationModal = ({
    buttonColorStyle = Colors.heavyRed,
    confirmButtonText = 'Confirmar',
    footerAlignment = 'right',
    isCancelButtonVisible = true,
    isCloseIconVisible,
    isLoading,
    isVisible,
    renderMessage,
    title,
    onConfirm,
    onClose,
}) => {
    return (
        <ModalResponsive
            closeIconVisible={isCloseIconVisible}
            title={title}
            visible={isVisible}
            onClose={onClose}
        >
            <ModalContainer>
                <BodyContainer>{renderMessage}</BodyContainer>
                <FooterContainer alignment={footerAlignment}>
                    {isCancelButtonVisible && (
                        <CancelButton
                            buttonColorStyle={buttonColorStyle}
                            loading={isLoading}
                            onClick={onClose}
                        >
                            Cancelar
                        </CancelButton>
                    )}
                    <ConfirmButton
                        buttonColorStyle={buttonColorStyle}
                        loading={isLoading}
                        onClick={onConfirm}
                    >
                        {confirmButtonText}
                    </ConfirmButton>
                </FooterContainer>
            </ModalContainer>
        </ModalResponsive>
    )
}

const ModalContainer = styled.div`
    width: 500px;
    padding: 24px;
`

const BodyContainer = styled.div`
    font-family: Roboto;
    font-size: 14px;
`

const FooterContainer = styled.div`
    display: flex;
    padding-top: 35px;
    justify-content: ${({ alignment }) =>
        alignment === 'center' ? 'center' : 'flex-end'};
`

const CancelButton = styled(RoundButton)`
    margin-right: 12px;
    background-color: ${Colors.white};
    color: ${({ buttonColorStyle }) => buttonColorStyle};
    border-color: ${({ buttonColorStyle }) => buttonColorStyle};
    font-family: Roboto;
    font-size: 14px;
    padding: 8px 36px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ConfirmButton = styled(RoundButton)`
    background-color: ${({ buttonColorStyle }) => buttonColorStyle};
    color: ${Colors.white};
    border-color: ${({ buttonColorStyle }) => buttonColorStyle};
    font-family: Roboto;
    font-size: 14px;
    padding: 8px 36px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export default ConfirmationModal
